// src/services/tourStatement.service.js
import api from './api';

const tourStatementService = {
  // Create tour statement
  createTourStatement: async (data) => {
    try {
      const response = await api.post('/tour-statements', data);
      return response.data;
    } catch (error) {
      console.error('Error creating tour statement:', error);
      throw error;
    }
  },

  // Get tour statements by user
  getTourStatementsByUser: async (userId) => {
    try {
      const response = await api.get(`/tour-statements/user/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching tour statements:', error);
      throw error;
    }
  },

  // Get tour statements by company
  getTourStatementsByCompany: async (companyId) => {
    try {
      const response = await api.get(`/tour-statements/company/${companyId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching tour statements:', error);
      throw error;
    }
  },

  // Get tour statement by ID
  getTourStatementById: async (id) => {
    try {
      const response = await api.get(`/tour-statements/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching tour statement:', error);
      throw error;
    }
  },

  // Update tour statement
  updateTourStatement: async (id, data) => {
    try {
      const response = await api.post(`/tour-statements/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating tour statement:', error);
      throw error;
    }
  },

  // Delete tour statement
  deleteTourStatement: async (id) => {
    try {
      const response = await api.delete(`/tour-statements/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting tour statement:', error);
      throw error;
    }
  },
};

export default tourStatementService;